export default __webpack_public_path__ + "static/media/nauEmblem.8fbdf991.png";